import { Button, FlexBox } from "@ui5/webcomponents-react";
import i18n from "../../../../services/i18n";

export default function ChoseBase({ onSubmit, prevs, close, bases, loading }) {

    return (
        <FlexBox
            direction="Column"
            alignItems="Center"
            justifyContent="Center"
            style={{ height: '100vh', backgroundColor: '#f1f1f1f1' }}
        >
            <FlexBox
                direction="Column"
                justifyContent="Center"
                alignItems="Center"
                style={{
                    backgroundColor: '#fff',
                    padding: 40,
                    borderRadius: 10,
                    border: '1px solid #ccc',
                    paddingBottom: 30
                }}
            >


                <img
                    style={{ height: 100, resize: 'contain' }}

                    src="/logo-large.png"
                    alt="Workflow"
                />

                <label style={{ fontWeight: 'bold', marginBottom: 10, marginTop: 20 }}>{i18n.t('selectBase')}</label>

                {
                    bases.map((v, i) => (
                        <Button
                            disabled={loading}
                            justifyContent="Center"
                            alignItems="Center"
                            style={{
                                width: '100%',
                                marginBottom: 20,
                                marginTop: 20,
                            }}
                            design=""
                            onClick={() => onSubmit(v.id)}
                            key={i}
                        >
                            {v.nome}
                        </Button>
                    ))
                }
                <FlexBox
                    direction="Row"
                    justifyContent="SpaceBetween"
                    alignItems="Center"
                    style={{ width: '100%', marginTop: '1rem' }}
                    aria-busy={loading}
                >
                    <Button
                        icon="arrow-left"
                        design="Emphasized"
                        onClick={prevs}
                        disabled={loading}
                        style={{ width: '100%' }}
                    >{i18n.t('back')}</Button>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    )

}